import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HIS_PAST_OPTIONS } from '@/pages/Onboarding/options/HisPast/HIS_PAST_OPTIONS';
import { getHisPastTitleById } from '@/pages/Onboarding/options/HisPast/utils/getHisPast';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const HisPastScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HisPast',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const hisPast = form.watch('his_past');

  const handleSelect = (option: OnbOptionType<LayoutDataType['his_past']>) => {
    form.setValue('his_past', option.id);
  };

  const handleNextStep = () => {
    const hisPastTitle = getHisPastTitleById(hisPast);
    userService.createOrUpdate({
      onboarding_data: {
        his_past: hisPastTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What's in His Past?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {HIS_PAST_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={hisPast === option.id}
              control={form.control}
              option={option}
              name="his_past"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!hisPast}
      />
    </OnboardingPage>
  );
};
